// Id de idempotência do despacho de rota (ver DispatchRouteService no
// backend) — gerado uma vez por tentativa de envio e reenviado igual em toda
// retentativa (clique duplo, "escolher conexão", "confirmar risco" etc), pra
// o servidor nunca processar o mesmo despacho duas vezes. Mesmo padrão do
// clientId de mensagem (ver utils/outbox.js), só que num arquivo próprio
// porque route dispatch não tem fila offline ainda (é usado hoje só pra
// proteger contra duplicidade dentro da MESMA sessão, não entre reload/app
// fechado).
export const generateRouteDispatchClientId = () => {
  try {
    if (typeof window !== "undefined" && window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }
  } catch (e) {}
  return (
    "route-" +
    Date.now().toString(36) +
    "-" +
    Math.random().toString(36).slice(2, 12) +
    Math.random().toString(36).slice(2, 6)
  );
};
